import { Component, OnInit, Directive, ElementRef, Compiler,
    HostListener, Input ,ChangeDetectionStrategy} from '@angular/core';
import { ManageServices } from './exampackage.service';
import * as $ from 'jquery';
declare var OnSuccessTakeTest: any;
declare var RetakeExamHandler: any;
declare var OnsuccessViewCFFactorSolution: any;
declare var GetSolutionDetailsByRowIndexSuccess: any,_:any;
import {ITestListRequest} from '../_models/ITestListRequest'
import { PagerService } from '../_services/PagerService'
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
    selector: 'exam',
    templateUrl: './exampackage.component.html',
    providers: [ManageServices],
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Default
})

export class ExamPackageComponent implements OnInit {
         page:any={testsPerPage:3};
         p:number=1;
         SliderPage:any={startIndex:'',endIndex:'',pages:''};
        examList: any;
        firstExam: any;
        assessmentList: any;
        sliderAssessmentList:any;
        ItestReq:ITestListRequest;
         pager: any = {};
         selectedExamCode:any;
         selectedPageNo:any=1;
          

       
    constructor(private manageService: ManageServices,private pagerService:PagerService) {  }
 ngOnInit() {
        this.LoadThemeCss()
        $("#progress").show(); $("#dvopacityscreen").show();
        this.ItestReq={ PID:0,PSize:3,PNo:1, StartDate:'',EndDate :'',  SearchType :0,  RID:0 }
        this.manageService.getExamDetails(this.ItestReq).subscribe(reResponse => {
            this.examList = reResponse.d;
            this.firstExam = this.examList[0].ExamCode;
            this.selectedExamCode=this.firstExam;
               this.setPage(1,1,this.examList[0].TotalRows, this.ItestReq.PSize);
            this.manageService.getAssessmentDetails(this.firstExam,1,this.page.testsPerPage).subscribe(asResponse => {
                $("#progress").hide(); $("#dvopacityscreen").hide();
                this.assessmentList = asResponse.d.lstTestList;
                this.GetPagerPageList(1,this.assessmentList[0].TotalRows,this.page.testsPerPage);
              });
        });
    }
OnchangePageNumber(testsPerPage){
            testsPerPage==""||0?this.page.testsPerPage=1:this.page.testsPerPage=testsPerPage
            this.page.testsPerPage=parseInt(this.page.testsPerPage);
                 $("#progress").show(); $("#dvopacityscreen").show();
      this.manageService.getAssessmentDetails(this.selectedExamCode,this.selectedPageNo,this.page.testsPerPage).subscribe(asResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
            this.assessmentList = asResponse.d.lstTestList;
            this.GetPagerPageList(1,this.assessmentList[0].TotalRows,this.page.testsPerPage);
               
        });
}

//Slider Pagination
  setPage(type,page: number,totalRows:number,pageSize) {
      switch(type){
          case 1:
          if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        this.pager = this.pagerService.getPager(totalRows, page,pageSize);
        break;
        case 2:
           $("#progress").show(); $("#dvopacityscreen").show();
           this.ItestReq={ PID:0,PSize:3,PNo:page, StartDate:'',EndDate :'',  SearchType :0,  RID:0 }
            this.manageService.getExamDetails(this.ItestReq).subscribe(reResponse => {
            this.examList = reResponse.d;
            this.firstExam = this.examList[0].ExamCode;
            this.setPage(1,page, this.examList[0].TotalRows,this.ItestReq.PSize);
            this.manageService.getAssessmentDetails(this.firstExam,1,this.page.testsPerPage).subscribe(asResponse => {
                $("#progress").hide(); $("#dvopacityscreen").hide();
                this.assessmentList = asResponse.d.lstTestList;
                this.GetPagerPageList(1,this.assessmentList[0].TotalRows,this.page.testsPerPage);
            });
        });

        break;
      }
        
    }

GetPagerPageList(isInitial,pageSize,testsPerPage){
     switch(isInitial){
             case 1:
               var totalPages = Math.ceil(pageSize / testsPerPage);
               this.SliderPage.pages=totalPages;
               return this.SliderPage;
     }
}
  myOnUpdate(obj){  }
  myOnChange(obj){  }
  myOnFinish(obj){
      if(this.selectedPageNo==obj.from)return true;
      this.selectedPageNo=obj.from;
      $("#progress").show(); $("#dvopacityscreen").show();
      this.manageService.getAssessmentDetails(this.selectedExamCode,obj.from,this.page.testsPerPage).subscribe(asResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
            this.assessmentList = asResponse.d.lstTestList;
            this.GetPagerPageList(1,this.assessmentList[0].TotalRows,this.page.testsPerPage);
               
        });
    }
//Ends here
LoadThemeCss() {
       var  CssFileList = []
                    CssFileList.push("../StyleSheet/Gray/style.css");
                    CssFileList.push("../StyleSheet/BootStrapCss/css/bootstrap.min.css");
                    CssFileList.push("../StyleSheet/Gray/exampackagestyle.css");

        CssFileList.filter(function (obj) {
            var fileref = document.createElement('link');
            fileref.rel = 'stylesheet';
            fileref.href = obj;
            fileref.media = 'all';
            fileref.type = 'text/css';
            var x = document.getElementsByTagName('head')[0];
            x.appendChild(fileref);

        });
    }

    clickExam(examCode,obj) {
        this.selectedExamCode=examCode;
        $("#progress").show(); $("#dvopacityscreen").show();
        for (let exam = 0; exam < obj.examList.length; exam++) {
            if (examCode == obj.examList[exam].ExamCode) {
                $("#" + obj.examList[exam].ExamCode).css("background-color", "rgb(209, 209, 224)");
            }
            else
            {
                $("#" + obj.examList[exam].ExamCode).css("background-color", "");
            }
        }
        this.manageService.getAssessmentDetails(examCode,1,this.page.testsPerPage).subscribe(asResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
            this.assessmentList = asResponse.d.lstTestList;
             this.GetPagerPageList(1,this.assessmentList[0].TotalRows,this.page.testsPerPage);
               
        });
    }   
}

@Directive({
    selector: '[startClick]'
})
export class startClickDirective implements OnInit {
    @Input('startClick') assessment: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        $("#progress").show(); $("#dvopacityscreen").show();
        this.manageService.TakeTest(this.assessment.ScheduleUserID).subscribe(testResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
            OnSuccessTakeTest(testResponse);
        });

    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[ViewBadge]'
})
export class ViewBadgeDirective implements OnInit {
    @Input('ViewBadge') rowIndex: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        $("#progress").show(); $("#dvopacityscreen").show();
        this.manageService.ViewBadges(this.rowIndex).subscribe(badgeResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
            var dimension = "top=0, left=0, resizable=no, fullscreen=yes, toolbar=no, titlebar=no, width=" + (screen.width) / 1.2 + ", height=" + (screen.availHeight / 1.2) + ", scrollbars=no";
            window.open(badgeResponse, "_MyBadges", dimension);
        });

    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[reportClick]'
})
export class reportClickDirective implements OnInit {
    @Input('reportClick') assessment: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        $("#progress").show(); $("#dvopacityscreen").show();
        var CurrentSUID = '';
        if (typeof (this.assessment.PreviousSUID) != 'undefined' && this.assessment.PreviousSUID != null && this.assessment.PreviousSUID > 0)
            CurrentSUID = this.assessment.PreviousSUID;
        else
            CurrentSUID = this.assessment.ScheduleUserID;
        this.manageService.getReport(CurrentSUID).subscribe(reportResponse => {
            OnsuccessViewCFFactorSolution(reportResponse);
        });

    }
    ngOnInit() {

    }
}
@Directive({
    selector: '[retakeClick]'
})
export class retakeClickDirective implements OnInit {
    @Input('retakeClick') assessment: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        $("#progress").show(); $("#dvopacityscreen").show();
        this.manageService.getRetake().subscribe(retakeResponse => {
            RetakeExamHandler.CallRetake(this.assessment.IndexOfTest);
        });

    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[statusVal]'
})
export class statusValDirective implements OnInit {
    @Input('statusVal') assessment: any;
    constructor(private eleRef: ElementRef) { }
   
    ngOnInit() {
        var className = "";
        switch (this.assessment.StatusValue) {
            case 0: className = "cl4"
                break;
            case 1:
                className = "cl3"
                break;
            case 2:
                className = "cl1"
                if (this.assessment.TestResultStatus.toLowerCase() == "pass" && this.assessment.EnableView) className = "cl1";
                if (this.assessment.EnableRetake && this.assessment.TestResultStatus.toLowerCase() == "fail") className = "cl2";
                if (!this.assessment.EnableRetake && this.assessment.TestResultStatus.toLowerCase() == "fail") className = "cl2";
                break;
            default:
                if (!this.assessment.EnableRetake && !this.assessment.EnableStartButton) className = "cgray";
                else if (this.assessment.Status == 1 && this.assessment.EnableStartButton) className = "cl3";
        }
        switch (this.assessment.Status) {
            case 'ATTEMNOTCOMPLDEXP':
            case 'NOTATTEMTEXP':
                className = "cl5";
                break;
        }
        $(this.eleRef.nativeElement).addClass(className)
    }
}



@Directive({
    selector: '[FindProctor]'
})
export class FindProctorDirective implements OnInit {
    @Input('FindProctor') rowIndex: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        $("#progress").show(); $("#dvopacityscreen").show();
        this.manageService.FindProctor().subscribe(procResponse => {
            $("#progress").hide(); $("#dvopacityscreen").hide();
          //  var url = response.d + "&iSarasTokenID=" + '<%=Session["iSarasTokenID"] %>' + "&From=" + '<%=Session["iSarasFrom"] %>' + "&Module=" + '<%=Session["iSarasModule"] %>';
           // location.href = url;
        });

    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[certificateClick]'
})
export class certificateClickDirective implements OnInit {
    @Input('certificateClick') assessment: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        this.manageService.ViewCertificationBasedonLevels(1, this.assessment.ScheduleUserID).subscribe(certResponse => {
            OnsuccessViewCFFactorSolution(certResponse);
        });
    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[solutionClick]'
})
export class solutionClickDirective implements OnInit {
    @Input('solutionClick') assessment: any;
    constructor(private eleRef: ElementRef, private manageService: ManageServices) { }
    @HostListener('click', ['$event']) onClick($event) {
        this.manageService.ViewSolution(this.assessment.IndexOfTest, this.assessment.TestID).subscribe(solResponse => {
            GetSolutionDetailsByRowIndexSuccess(solResponse);
        });
    }
    ngOnInit() {

    }
}

@Directive({
    selector: '[calDuration]'
})
export class calDurationDirective implements OnInit {
    @Input('calDuration') assessment: any;
    constructor(private eleRef: ElementRef) { }
    ngOnInit() {
        var _hour: any = Math.floor(this.assessment.Duration / 3600);
        var _minutes: any = Math.floor(this.assessment.Duration % 3600 / 60);
        var _seconds: any = Math.floor(this.assessment.Duration % 3600 % 60);
        _hour = _hour > 9 ? _hour : "0" + _hour;
        _minutes = _minutes > 9 ? _minutes : "0" + _minutes;
        _seconds = _seconds > 9 ? _seconds : "0" + _seconds;
        this.eleRef.nativeElement.innerHTML = _hour + ":" + _minutes + ":" + _seconds;
    }
}

@Directive({
    selector: '[iconClass]'
})
export class iconClassDirective implements OnInit {
    @Input('iconClass') assessment: any;
    constructor(private eleRef: ElementRef) { }

    ngOnInit() {
        var className = "";
        if (this.assessment.VerificationImageRequired) {
            className = "sa-photo-capture";
           // $(this.eleRef.nativeElement).nativeElement.parent().append('<i style="Position:relative;padding:2px" icon-class class="icon mrgtp ' + className + '"   title="Photo Capturing Enabled"></i>');
        }
        if (this.assessment.SequenceNumber > 0) {
            className = "sa-sequence";
            $(this.eleRef.nativeElement).parent().append('<i style="Position:relative;padding:2px" icon-class class="icon mrgtp ' + className + '"   title="Sequencing"></i>');
        }
        if (typeof (this.assessment.IsSecuredTest) != 'undefined' && this.assessment.IsSecuredTest) {
            className = "sa-secure";
            $(this.eleRef.nativeElement).parent().append('<i style="Position:relative;padding:2px" icon-class class="icon mrgtp ' + className + '"   title="Secure Browser"></i>');
        }
        if (typeof (this.assessment.IsCriteriaEnabled) != 'undefined' && this.assessment.IsCriteriaEnabled) {
            className = 'sa-page-list';
            $(this.eleRef.nativeElement).parent().append('<i style="Position:relative;padding:2px" icon-class class="icon mrgtp ' + className + '"   title="Criteria Based Assessments"></i>');
        }
    }
}

@Directive({
    selector: '[roundClass]'
})
export class roundClassDirective implements OnInit {
    @Input('roundClass') assessment: any;
    constructor(private eleRef: ElementRef) { }

    ngOnInit() {
        var className = "";
        switch (this.assessment.Status) {
            case 'COMPLETED':
                if (this.assessment.EnableRetake && typeof (this.assessment.TestResultStatus) != 'undefined' && this.assessment.TestResultStatus.toLowerCase() == "fail") className = "icon sa-unlock"
                else if (typeof (this.assessment.TestResultStatus) != 'undefined' && this.assessment.TestResultStatus.toLowerCase() == 'pass' && !this.assessment.EnableStartButton) className = "icon sa-tick"
                break;
            case 'NOTATTEMP':
                if (this.assessment.EnableStartButton) className = "icon sa-unlock";
                break;
            case 'STARTNOTCOMP':
                if (this.assessment.EnableStartButton || this.assessment.EnableRetake) className = "icon sa-unlock";
                break;
            case 'ATTEMNOTCOMPLDEXP':
            case 'NOTATTEMTEXP':
                $(this.eleRef.nativeElement).removeClass('sa-lock');
                className = "sa-lock";
                $(this.eleRef.nativeElement).css("color", "#ea0f0f");
                break;
            default:
                if (!this.assessment.EnableStartButton && !this.assessment.EnableRetake) className = "icon sa-lock";
                break;
        }
        $(this.eleRef.nativeElement).addClass(className)
    }
}

export class Exam {

}







// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/exampackage/exampackage.component.ts